// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8582) return "static/chunks/8582-76be82457af3f4f0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"463":"6b05d4f2a3b2e957","684":"2e8e0775338fe33f","919":"28560337c0583705","2634":"112eafd087cb1244","4548":"603abd7b1a320317"}[chunkId] + ".js";
};